import { render, staticRenderFns } from "./ProjectGroup.vue?vue&type=template&id=b43cfb30&scoped=true"
import script from "./ProjectGroup.vue?vue&type=script&lang=js"
export * from "./ProjectGroup.vue?vue&type=script&lang=js"
import style0 from "./ProjectGroup.vue?vue&type=style&index=0&id=b43cfb30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43cfb30",
  null
  
)

export default component.exports